/**
 * Custom error classes for the application
 */

/**
 * Base application error class
 */
export class AppError extends Error {
  constructor(message, code = 'APP_ERROR', statusCode = 500) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    this.statusCode = statusCode;
    
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}

/**
 * Onboarding specific error class
 */
export class OnboardingError extends AppError {
  constructor(message, code = 'ONBOARDING_ERROR') {
    super(message, code, 400);
  }
}

/**
 * Data transformation error class
 */
export class DataTransformationError extends AppError {
  constructor(message, originalData = null, code = 'DATA_TRANSFORMATION_ERROR') {
    super(message, code, 422);
    this.originalData = originalData;
  }
}

/**
 * API response error class
 */
export class APIResponseError extends AppError {
  constructor(message, options = {}) {
    const { 
      statusCode = 500, 
      code = 'API_RESPONSE_ERROR',
      originalError = null,
      context = null
    } = options;
    
    super(message, code, statusCode);
    this.originalError = originalError;
    this.context = context;
    this.statusCode = statusCode;
  }
}
